export default __webpack_public_path__ + "static/media/START_Extrusion.15980718.pdf";